import React, { useMemo, useState } from "react"
import FabricImageEditor from "../Components/Canvas/canvas";
import { FaSpinner } from "react-icons/fa";
import { MdOutlineVideoLibrary } from "react-icons/md";
import axiosConfig from "../Service/axiosConfig";
const PostUpload = (props) => {
    console.log("props in post upload", props)
    const { handleEditProfileClose, loading, setLoading, popupType, setpopupType, profile_id, id, showPhotoModal, setShowPhotoModal, showVideoModal, setShowVideoModal } = props
    const [caption, setCaption] = useState("");
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [videoPreview, setVideoPreview] = useState("");
    const [videoError, setVideoError] = useState("");
    const acceptedVideoTypes = useMemo(
        () => [
            "video/mp4",
            "video/quicktime",
            "video/webm",
            "video/x-msvideo",
            "video/x-matroska",
        ],
        []
    );
    const supportedFormatsLabel = "MP4, MOV, WEBM, AVI, MKV";
    const resetVideoState = () => {
        if (videoPreview) URL.revokeObjectURL(videoPreview);
        setSelectedVideo(null);
        setVideoPreview("");
        setVideoError("");
    };
    const handleVideoModalClose = () => {
        setShowVideoModal(false);
        setLoading(false);
        resetVideoState();
    };
    const handleVideoChange = (event) => {
        const file = event.target.files?.[0];
        setVideoError("");
        if (!file) return;

        if (!acceptedVideoTypes.includes(file.type)) {
            setVideoError(`Unsupported format. Supported formats: ${supportedFormatsLabel}.`);
            event.target.value = "";
            return;
        }
        if (file.size > 50 * 1024 * 1024) {
            setVideoError("Video must be less than 50MB after crop/compression.");
            event.target.value = "";
            return;
        }

        if (videoPreview) URL.revokeObjectURL(videoPreview);
        setSelectedVideo(file);
        setVideoPreview(URL.createObjectURL(file));
    };

    const handleVideoUpload = async () => {
        if (!selectedVideo) {
            setVideoError("Please choose a video first.");
            return;
        }
        if (selectedVideo.size > 50 * 1024 * 1024) {
            setVideoError("Video must be less than 50MB after crop/compression.");
            return;
        }

        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("video", selectedVideo);
            await axiosConfig.post(`accounts/model-images/create_video/?profile_id=${profile_id ? profile_id : id}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            handleVideoModalClose();
            // setShowVideoSuccessModal(true);
        } catch (error) {
            setVideoError("Error while uploading video. Please try another video.");
            console.error("Error creating video post:", error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            {showPhotoModal &&
                <FabricImageEditor
                    setCaption={setCaption}
                    caption={caption}
                    setLoading={setLoading}
                    loading={loading}
                    setpopupType={setpopupType}
                    setAddPost={handleEditProfileClose}
                    popupType={popupType}
                    profile_id={profile_id}
                />
            }
            {showVideoModal &&
                <div>
                    <div className="text-center">
                        <MdOutlineVideoLibrary size={48} />
                        <p className="mt-2 mb-3">Drag videos here or choose from your computer</p>
                        <label className="btn btn-primary">
                            Select video from computer
                            <input
                                type="file"
                                accept=".mp4,.mov,.webm,.avi,.mkv,video/mp4,video/quicktime,video/webm,video/x-msvideo,video/x-matroska"
                                hidden
                                onChange={handleVideoChange}
                            />
                        </label>
                    </div>

                    {videoError && <div className="alert alert-danger mt-3">{videoError}</div>}

                    <div className="mt-3">
                        <small className="text-muted d-block">Supported formats: {supportedFormatsLabel}</small>
                        <small className="text-muted d-block">Max file size: 50MB</small>
                        <small className="text-muted d-block">Crop option: please pre-crop/compress before upload if needed.</small>
                    </div>

                    {videoPreview && (
                        <div className="mt-3">
                            <video controls width="100%" src={videoPreview} style={{ borderRadius: "6px", maxHeight: "360px" }} />
                            <div className="mt-2 text-muted">{selectedVideo?.name}</div>
                        </div>
                    )}

                    <button className="btn btn-primary w-100 mt-3" disabled={loading || !selectedVideo} onClick={handleVideoUpload}>
                        {loading ? <FaSpinner className="spin-icon" /> : "Upload Video"}
                    </button>
                </div>
            }
        </>
    )
}
export { PostUpload }